import { render, staticRenderFns } from "./my-account.vue?vue&type=template&id=f4510fca&scoped=true&"
import script from "./my-account.vue?vue&type=script&lang=js&"
export * from "./my-account.vue?vue&type=script&lang=js&"
import style0 from "./my-account.vue?vue&type=style&index=0&id=f4510fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4510fca",
  null
  
)

export default component.exports